import Swiper from 'swiper';
import { A11y, Navigation, EffectFade } from 'swiper/modules';
Swiper.use([ A11y, Navigation, EffectFade]);

jQuery(document).ready(function() {
  if (jQuery('.swiper-specs').length) {
    new Swiper('.swiper-specs', {
      slidesPerView: 1,
      spaceBetween: 150,
      speed: 1000,
      loop: true,
      a11y: {
        enabled: true,
      },
      navigation: {
        nextEl: '.swiper-navigation .swiper-button-next',
        prevEl: '.swiper-navigation .swiper-button-prev',
      },
    });
  }

  if (jQuery('.swiper-specs-gallery').length && jQuery('.swiper-specs-thumbs').length) {

    let slides = [];

    jQuery('.swiper-specs-gallery').each(function(i) {
      slides.push({
        gallery: new Swiper(`.swiper-specs-gallery-${ i + 1 }`, {
          slidesPerView: 1,
          spaceBetween: 15,
          speed: 1000,
          effect: 'fade',
          a11y: {
            enabled: true,
          },
        }),
        thumbs: new Swiper(`.swiper-specs-thumbs-${ i + 1 }`, {
          slidesPerView: 3,
          spaceBetween: 25,
          speed: 1000,
          a11y: {
            enabled: true,
          },
        }),
      });
    });

    let thumbs = jQuery('.swiper-specs-thumbs button.swiper-slide');
    thumbs.each(function() {
      let thumb = jQuery(this);
      let slideIndex = thumb.data().slide;
      let imageIndex = thumb.data().image;
      let slideObj = slides.find(slide => {
        return slide.gallery.el.classList.contains(`swiper-specs-gallery-${ slideIndex }`);
      });
      thumb.click(function() {
        slideObj.gallery.slideTo(imageIndex);
      });
    });
  }
});
